import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
  selector: "app-init-modal",
  templateUrl: "./init-modal.component.html",
  styleUrls: ["./init-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class InitModalComponent {
  readonly #modalRef = inject(BsModalRef);

  public closeModal(): void {
    this.#modalRef.hide();
  }
}
